import { ColumnDef } from "@tanstack/react-table";
import { DataTableColumnHeader } from "./data-table-column-header";
import { Badge, BadgeProps } from "@/components/ui/badge";
import { QueryConnectionsEnum } from "@/enum/queryStatus";
import { DataTableRowActions } from "./data-table-row-actions";

const queryStatusConfig: Record<
  QueryConnectionsEnum,
  { text: string; variant: BadgeProps["variant"] }
> = {
  [QueryConnectionsEnum.ENABLED]: { text: "Ativo", variant: "approved" },
  [QueryConnectionsEnum.DISABLED]: {
    text: "Desabilitado",
    variant: "reproved",
  },
  [QueryConnectionsEnum.PAUSED]: { text: "Pausado", variant: "pending" },
};

export const columns: ColumnDef<any>[] = [
  {
    accessorKey: "Apelido",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Apelido" />
    ),
    cell: ({ row }) => <div>{row.original.connection_nickname}</div>,
  },
  {
    accessorKey: "Banco",
    header: ({ column }) => (
      <DataTableColumnHeader
        column={column}
        title="Conexão do Banco"
        className=""
      />
    ),
    cell: ({ row }) => {
      const text = row.original.connection_db;
      return text;
    },
  },
  {
    accessorKey: "Tipo",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Tipo de Conexão" />
    ),
    cell: ({ row }) => <div>{row.original.connection_type}</div>,
  },
  {
    accessorKey: "Select Permitido",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Select Permitido" />
    ),
    cell: ({ row }) => (
      <Badge className="bg-transparent border border-black/10">
        {row.original.select_allowed === true ? "Sim" : "Não"}
      </Badge>
    ),
  },
  {
    accessorKey: "Updates Permitidos",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Updates Permitidos" />
    ),
    cell: ({ row }) => (
      <Badge className="bg-transparent border border-black/10">
        {row.original.updates_allowed === true ? "Sim" : "Não"}
      </Badge>
    ),
  },
  {
    accessorKey: "connection_status",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Status" />
    ),
    cell: ({ row }) => {
      const status = row.getValue("connection_status") as QueryConnectionsEnum;
      const config = queryStatusConfig[status] || {
        text: "Desconhecido",
        variant: "default",
      };

      return <Badge variant={config.variant}>{config.text}</Badge>;
    },
  },

  {
    id: "actions",
    cell: ({ row }) => <DataTableRowActions row={row} />,
  },
];
